import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { AppConfigService } from "src/app/app-config.service";
import { CommonService } from "../../common-service";
import { TemplateMedicineGroupRequest } from "../../requests/pharmacy/template-medicine-group.request";
import { GetTemplateMedicineGroupResponse } from "../../responses/pharmacy/get-template-medicine-group.response";
import { ListTemplateMedicineGroupResponse } from "../../responses/pharmacy/list-template-medicine-group.response";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";



@Injectable({
  providedIn: 'root'
})
export class TemplateMedicineGroupService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService
  ) {
    super(configService);
  }

  public listTemplateMedicineGroup(searchText: string, idTemplate: number): Observable<ListTemplateMedicineGroupResponse> {
    let uri = "TemplateMedicineGroup?"
    if (searchText)
      uri = uri + `searchText=${searchText}`;

    if (idTemplate)
      uri = uri + `&idTemplate=${idTemplate}`;

    return this.httpClient.get<ListTemplateMedicineGroupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public listAllTemplateMedicineGroup(): Observable<ListTemplateMedicineGroupResponse> {
    let uri = "TemplateMedicineGroup/getAll"

    return this.httpClient.get<ListTemplateMedicineGroupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public getTemplateMedicineGroup(idMedicineGroup: number): Observable<GetTemplateMedicineGroupResponse> {
    let uri = `TemplateMedicineGroup/idMedicineGroup/${idMedicineGroup}`

    return this.httpClient.get<GetTemplateMedicineGroupResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public createTemplateMedicineGroup(request: TemplateMedicineGroupRequest): Observable<ReturnStruct> {
    let uri = `TemplateMedicineGroup`

    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateTemplateMedicineGroup(idMedicineGroup: number, request: TemplateMedicineGroupRequest): Observable<ReturnStruct> {
    let uri = `TemplateMedicineGroup/idMedicineGroup/${idMedicineGroup}`

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public deleteTemplateMedicineGroup(idMedicineGroup: number): Observable<ReturnStruct> {
    let uri = `TemplateMedicineGroup/idMedicineGroup/${idMedicineGroup}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
